module.exports = __webpack_public_path__ + "static/media/sss-contribution.905ebf2e.svg";